import { css } from '../lib';

export const alignX = css`
  &[data-align='left'] {
    justify-content: flex-start;
  }
  &[data-align='center'] {
    justify-content: center;
  }
  &[data-align='right'] {
    justify-content: flex-end;
  }
`;

export const alignY = css`
  &[data-align='top'] {
    align-items: flex-start;
  }
  &[data-align='center'] {
    align-items: center;
  }
  &[data-align='bottom'] {
    align-items: flex-end;
  }
`;
